import { LogLevel } from '@amplitude/analytics-types';
import { logEventProperties, logUserProperties, writeLog } from './log';
let remapConfig = {
  eventTypes: {},
  eventProperties: {}
};
const name = 'remapNames';
const type = 'enrichment';
let debug = false;
const setup = async function (config) {
  /* istanbul ignore next */
  debug = config.logLevel === LogLevel.Debug;
};
const execute = async function (event) {
  var _event$user_propertie;
  const log = {};
  const originalEventType = event.event_type;
  const remappedEventType = remap(remapConfig.eventTypes, event.event_type);
  event.event_type = remappedEventType;
  /* istanbul ignore next */
  if (debug && originalEventType !== remappedEventType) {
    log.event_type = `${originalEventType}`;
  }

  // When user properties are passed on a track event.
  if (event.user_properties) {
    const original = event.user_properties;
    const mapped = remapPropertyNames(original);
    event.user_properties = mapped;
    logUserProperties(debug, log, original, mapped);
  }

  // When user properties are passed on an identify event.
  if ((_event$user_propertie = event.user_properties) !== null && _event$user_propertie !== void 0 && _event$user_propertie.$set) {
    const original = event.user_properties.$set;
    const mapped = remapPropertyNames(original);
    event.user_properties.$set = mapped;
    logUserProperties(debug, log, original, mapped);
  }
  if (event.event_properties) {
    const original = event.event_properties;
    const mapped = remapPropertyNames(original);
    event.event_properties = mapped;
    logEventProperties(debug, log, original, mapped);
  }

  /* istanbul ignore next */
  if (debug) {
    writeLog(log, 'Amplitude naming remapping occurred', x => remap(remapConfig.eventTypes, x), x => remap(remapConfig.eventProperties, x));
  }
  return event;
};
const namingRemapingPluginConstructor = maps => {
  remapConfig = maps;
  const plugin = {
    name,
    type,
    setup,
    execute
  };
  return plugin;
};
export default namingRemapingPluginConstructor;
const remap = (map, value) => {
  if (!map) return value;
  return map[value] || value;
};
const remapPropertyNames = properties => {
  if (!remapConfig.eventProperties) return properties;
  const eventProperties = Object.entries(properties);
  const mappedEvents = eventProperties.map(([property, value]) => [remap(remapConfig.eventProperties, property), value]);
  return Object.fromEntries(mappedEvents);
};
//# sourceMappingURL=namingRemappingPlugin.js.map